import styled from 'styled-components';

import { HorizontalCenterColumnBlock } from '../../../../styled';

export const Wrapper = styled(HorizontalCenterColumnBlock)`
  padding: 20px;
  gap: 10px;
  color: ${(props) => `${props.theme.colors.brand}52`};
  background: ${(props) => props.theme.colors.overlay};
  border: 1px solid ${(props) => props.theme.colors.overlay};
  box-shadow: 0 1px 4px rgba(0, 36, 77, 0.08);
  border-radius: 4px;
`;

export const StyledLink = styled.div`
  ${(props) => props.theme.typography.subHeader3compact};
  color: ${(p) => p.theme.colors.brand};
  line-height: 24px;

  :hover {
    cursor: pointer;
  }
`;
